export class ListEventsError extends Error {}
